module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Accento — Dev/Java/JavaScript","short_name":"Accento","start_url":"/","background_color":"#88a42b","theme_color":"#88a42b","display":"minimal-ui","icon":"static/favicon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-142696857-1","head":true,"anonymize":true,"respectDNT":true,"cookieDomain":"auto"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
